<template>
  <div>
    <ui-input
      v-model="email"
      :error="hasError"
      :z-index-tooltip="2147483005"
      :error-triggers="['hover']"
      class="altcraft__input"
      type="email"
      placeholder="Enter your email"
      @focus="hasInteraction = true"
      @blur="hasInteraction = false" />
    <button
      class="button button-main altcraft__button"
      @click="subEmail">
      Subscribe
    </button>
  </div>
</template>

<script>
import { regExpEmail } from 'Root/helpers/regexps';
import UiInput from 'Components/ui/Input/UiInput.vue';

export default {
  name: 'AltcraftPopupEmail',

  components: {
    UiInput,
  },

  data: () => ({
    email: '',
    hasInteraction: false,
  }),

  computed: {
    hasError() {
      return !this.hasInteraction && !this.email.match(regExpEmail) && this.email.length > 0
        ? 'Please, enter a valid email'
        : false;
    },
  },

  methods: {
    subEmail() {
      if (this.hasError || this.email.length < 1) {
        return;
      }

      this.$emit('subEmail', this.email);
    },
  },
};
</script>

<style lang="scss" scoped>
  .altcraft__button {
    padding: 12px;
  }

  .altcraft__input {
    --height: 40px;
    --padding: 3%;
    --font-size: 13px;
    --color: #{$color--basic-white};
    --placeholder-color: #{$color--basic-white};
    --background-color: #{rgba($color--basic-white, .2)};
    --background-color--focused: #{rgba($color--basic-white, .2)};

    width: 100%;
    margin-right: 8px;
  }
</style>
